import React from "react";
import { Copy } from "lucide-react";

export default function SetAppointmentLeadDetailsCard({ lead, rows, onCopy }) {
  return (
    <div className="rounded-2xl bg-white/5 px-4 py-3 ring-1 ring-white/10" data-testid="set-appointment-lead-details-card">
      <div className="text-xs text-slate-200/60" data-testid="set-appointment-lead-details-title">
        Lead Details
      </div>
      <div className="mt-2 grid grid-cols-1 gap-2">
        {(rows || []).map((row) => (
          <div
            key={row.testId}
            className="flex items-center justify-between gap-3 rounded-xl bg-black/20 px-3 py-2"
            data-testid={`set-appointment-${row.testId}-row`}
          >
            <div className="min-w-0">
              <div className="text-[11px] uppercase text-slate-200/60" data-testid={`set-appointment-${row.testId}-label`}>
                {row.label}
              </div>
              <div className="truncate text-sm text-slate-100" data-testid={`set-appointment-${row.testId}-value`}>
                {row.value}
              </div>
            </div>
            <button
              type="button"
              className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 text-slate-100 hover:bg-white/20"
              onClick={() => onCopy(row.value, row.label)}
              data-testid={`set-appointment-${row.testId}-copy`}
            >
              <Copy className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
